
/**
 * Base class to save values that do not render HTML templates.
 *
 * This is a drop-in replacement for the chide.ui.Value that is used
 * in React components.  The legacy chide.ui.Value class handles rendering
 * HTML, but in this case, the React components wil handle the rendering but we
 * need a class that has the same method calls as the chide.ui.Value for when
 * passing this object back up to the legacy parent components.
 *
 * @export
 * @class Value
 */
export default class Value {
	internalValue;

	constructor(value, defaultValue) {
		if (defaultValue && value === undefined) {
			this.internalValue = defaultValue;
		} else {
			this.internalValue = value;
		}
	}

	get() {
		return this.internalValue;
	}

	set(value) {
		this.internalValue = value;
	}

	get value() {
		return this.internalValue;
	}

	set value(value) {
		this.internalValue = value;
	}
}
